import { useQuery } from '@tanstack/react-query';

import { fetchUnreadCount } from '../services';

type UseUnreadCountOptions = {
  enabled?: boolean;
};

export function useUnreadCount({ enabled = true }: UseUnreadCountOptions = {}) {
  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: async () => {
      const data = await fetchUnreadCount();
      return data.count;
    },
    refetchInterval: 60_000,
    enabled,
  });
}
